import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TableCell,
  TableRow,
  Typography,
} from "@material-ui/core";
import {
  STATE_FILTER_BED,
  getListBed,
  headCellsBedApplicares,
} from "App/Component/layout/MasterData/Bed/ui/TabGolonganKelas/helpers";
import {
  InputTextMaster,
  MasterButton,
  Modal,
  ModalDeleteConfirm,
  TableAction,
} from "App/Component/ui";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { defaultToastError, defaultToastSuccess } from "App/utils/helpers";
import { FreezeTable } from "components/organism";
import React, { useEffect, useState } from "react";
import { convertDate } from "./helpers";
import { Skeleton } from "@material-ui/lab";
import { instanceApplicares } from "App/constants";
import { itSelfEmpty } from "utils/all";
import { getUserName } from "App/utils/cookies";

export default function DialogBedApplicares({ setShowModal }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [selected, setSelected] = useState({});
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [formFilterBed, setFormFilterBed] = useState(STATE_FILTER_BED);

  const setNewData = async (
    pages = formFilterBed.pages,
    limit = formFilterBed.limit
  ) => {
    setLoading(true);

    const res = await getListBed(formFilterBed, pages, limit);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: itSelfEmpty(rows, []),
    orderByDefault: "namakelas",
    orderByRow: ["namakelas", "namaruang"],
  });

  useEffect(() => {
    setNewData();
  }, []);

  const filteredData =
    formFilterBed?.search_key === ""
      ? rows
      : itSelfEmpty(rows, []).filter(
          (row) =>
            row?.namakelas
              .split(" ")
              .join()
              .toLowerCase()
              .includes(
                formFilterBed.search_key.split(" ").join().toLowerCase()
              ) ||
            row?.namaruang
              .split(" ")
              .join()
              .toLowerCase()
              .includes(
                formFilterBed.search_key.split(" ").join().toLowerCase()
              )
        );

  const handleDelete = async (row) => {
    try {
      const payload = {
        kode_ppk: process.env.REACT_APP_KODE_PPK_RUJUKAN,
        kode_kelas: row.kodekelas,
        kode_ruang: row.koderuang,
        user: getUserName(),
      };

      const res = await instanceApplicares.post(
        "/api/v1/rsannisa/aplicares/delete/ruangan-hapus",
        payload
      );

      if (res.status === 200) {
        defaultToastSuccess(res.data?.metaData?.message);
        setNewData();
      }
    } catch (error) {
      defaultToastError("gagal menghapus data");
    }

    setShowModalDeleteConfirm(false);
  };

  return (
    <>
      <Dialog
        open={showModalDeleteConfirm}
        onClose={() => {
          setShowModalDeleteConfirm(false);
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Konfirmasi Hapus
        </DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            Harap konfirmasi hapus data bed applicares dengan data berikut:
          </Typography>
          <Typography gutterBottom variant="caption">
            Kode Kelas: {selected.kodekelas}
          </Typography>
          <br />
          <Typography gutterBottom variant="caption">
            Kode Ruang: {selected.koderuang}
          </Typography>
        </DialogContent>
        <DialogActions>
          <MasterButton
            name="Hapus"
            color="danger"
            type="button"
            onClick={() => handleDelete(selected)}
          />
        </DialogActions>
      </Dialog>
      <Modal width="80%" show={setShowModal} title="List Bed Applicares">
        <div
          style={{
            width: "250px",
            paddingBottom: "15px",
          }}
        >
          <InputTextMaster
            name="search_key"
            label="Cari Nama Kelas / Ruang"
            value={formFilterBed.search_key}
            onChange={(e) =>
              setFormFilterBed({ ...formFilterBed, search_key: e.target.value })
            }
            id="search_key"
          />
        </div>
        <FreezeTable
          headCells={headCellsBedApplicares}
          handleRequestSort={handleRequestSort}
          length={length}
          order={order}
          orderBy={orderBy}
        >
          {loading
            ? [1, 2, 3, 4, 5, 6, 7].map((itm) => (
                <TableRow>
                  {headCellsBedApplicares.map((item) => (
                    <TableCell>
                      <Skeleton animation="wave" />
                    </TableCell>
                  ))}
                </TableRow>
              ))
            : stableSort(filteredData, getComparator(order, orderBy)).map(
                (row, index) => {
                  return (
                    <TableRow hover key={index}>
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="center">
                        <TableAction
                          clickDelete={() => {
                            setSelected(row);
                            setShowModalDeleteConfirm(!showModalDeleteConfirm);
                          }}
                          isUpdate={false}
                        />
                      </TableCell>
                      <TableCell align="center">
                        {row.kodekelas ?? " - "}
                      </TableCell>
                      <TableCell align="center">
                        {row.namakelas ?? " - "}
                      </TableCell>
                      <TableCell align="center">
                        {row.koderuang ?? " - "}
                      </TableCell>
                      <TableCell align="center">
                        {row.namaruang ?? " - "}
                      </TableCell>
                      <TableCell align="center">
                        {row.kapasitas ?? " - "}
                      </TableCell>
                      <TableCell align="center">
                        {row.tersedia ?? " - "}
                      </TableCell>
                      <TableCell align="center">
                        {row.tersediapria ?? " - "}
                      </TableCell>
                      <TableCell align="center">
                        {row.tersediawanita ?? " - "}
                      </TableCell>
                      <TableCell align="center">
                        {row.tersediapriawanita ?? " - "}
                      </TableCell>
                      <TableCell align="center">
                        {convertDate(row.last_update) ?? " - "}
                      </TableCell>
                    </TableRow>
                  );
                }
              )}
        </FreezeTable>
      </Modal>
    </>
  );
}
